/* eslint-disable react-hooks/exhaustive-deps */
import useSeguridad from "../../Seguridad/useSeguridad";
import constantes from "../constantes";
import React, {useEffect, useState} from "react";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import {EditIconRenderer, GridEditHeader, ReadOnlyCheckBoxRenderer} from "../../shared/ag-grid-helper/GridRenderers";
import agGridHelper from "../../shared/ag-grid-helper";
import SideBarEditForm from "../../shared/forms/SideBarEditForm";
import Form from "../../shared/forms/Form";
import Field from "../../shared/forms/Field";
import FormTextBox from "../../shared/forms/FormFields/FormTextBox";
import useApiGeocercasGrupo from "../../api/catalogos/useApiGeocercasGrupo";
import FormColorPicker from "../../shared/forms/FormFields/FormColorPicker";

const GeocercasGrupo = () => {
    const seguridad = useSeguridad();
    const soloLectura = !seguridad.esEditable(constantes.menus.geocercasGrupo);
    const api = useApiGeocercasGrupo();

    const [datos, setDatos] = useState([]);
    const [currentId, setCurrentId] = useState(null);

    useEffect(() => {
        load().then();
    }, []);

    const load = async () => {
        const datos = await api.filtrar();
        setDatos(datos);
    };

    return (
        <>
            <div className="ag-theme-balham grid-principal">
                <AgGridReact
                    rowSelection={'single'}
                    enableSorting={true}
                    frameworkComponents={{
                        readOnlyCheckBoxRenderer: ReadOnlyCheckBoxRenderer,
                        editRenderer: EditIconRenderer,
                        editHeader: GridEditHeader
                    }}
                    defaultColDef={agGridHelper.defaultColumns}
                    rowData={datos}
                    context={{
                        onEdit: (id) => setCurrentId(id),
                        onAdd: () => setCurrentId(0)
                    }}
                >
                    <AgGridColumn field="nombre" headerName="NOMBRE" cellClass={'left'} />
                    <AgGridColumn field="color" headerName="COLOR" cellClass={'center'} />
                    <AgGridColumn field="enabled" headerName="ACTIVO" cellClass={'flex center align-center'}
                                  cellRenderer={'readOnlyCheckBoxRenderer'} />
                    <AgGridColumn maxWidth={60} headerComponent={soloLectura ? '' : 'editHeader'} cellClass={'center'}
                                  cellRenderer="editRenderer" />
                </AgGridReact>
            </div>

            <SideBarEditForm id={currentId}
                             initialValues={{ enabled: true }}
                             getByIdFunction={api.obtener}
                             saveFunction={api.guardar}
                             deleteFunction={api.eliminar}
                             formDisabled={soloLectura}
                             onSaved={() => {
                                 load().then();
                                 setCurrentId(null);
                             }}
                             onCancel={() => setCurrentId(null)}
            >
                <Form columns={1}>
                    <h5>Grupo de Geocercas</h5>
                    <Field field={"nombre"} label={"Nombre"} required={true} render={FormTextBox} disabled={true} />
                    <Field field={"color"} label={"Color"} required={true} render={FormColorPicker}  />
                </Form>
            </SideBarEditForm>
        </>
    );
};

export default GeocercasGrupo;